
import { Component, Injector, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { AbstractComponent, CampaignService, FirebaseService, UtilHelper, ZAPIData } from 'lib-trend-core';

@Component({
    selector: 'campaign-evo-template',
    templateUrl: './campaign-evo-template.v2.component.html',
    // templateUrl: './campaign-evo-template.component.html',
    styleUrls: ['./campaign-evo-template.v2.component.scss']
    // styleUrls: ['./campaign-evo-template.component.scss']
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class CampaignEvoTemplateComponent extends AbstractComponent implements OnInit, OnDestroy, OnChanges {
  avatarUrl: string = 'https://firebasestorage.googleapis.com/v0/b/infinite7-70f9d.appspot.com/o/blank.png?alt=media&token=fea2ea97-edbd-4589-a52e-e4b8d786be0b';

  @Input('zapiData') zapiData: ZAPIData;

  type: string;
  inputText: string;
  fileUrl: string;

  constructor(
    injector: Injector,
    public firebaseService: FirebaseService,
    public campaignService: CampaignService
  ) {
    super(injector);
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['zapiData']?.currentValue) {
      this.inputText = '';
      this.type = '';
      this.fileUrl = '';
      this.updateTemplateParams();
    }
  }

  updateTemplateParams(): void {
    if (!this.zapiData) return;

    this.inputText = this.zapiData.message || '';
    this.type = this.zapiData.type || '';
    this.fileUrl = this.zapiData.midia || '';
  }

  formatWhatsappMessage(text: string): string {
    return UtilHelper.formatWhatsappMessage(text);
  }
}
